import * as React from 'react';
import { Button } from '../button/Button';

interface IProps {
    onSave: any;
    onCancel : any;
}

export const FlyoutSaveCancel = (props : IProps) => {

    return <div className="stop-action-buttons">
            <div className="row">
                <div className="col">
                    <Button
                        id="stop-content-save-button"
                        classes="attention"
                        testID="stop-content-save-button"
                        text="Save"
                        onBtnClick={ props.onSave }
                    />
                </div>
                <div className="col">
                    <Button
                        id="stop-content-cancel-button"
                        testID="stop-content-cancel-button"
                        onBtnClick={ props.onCancel }
                        text="Cancel"
                    />
                </div>
            </div>
        </div>;
};
